import type { Map as MapboxMap } from 'mapbox-gl';

export const WIND_ARROW_ICON_ID = 'coordal-wind-arrow-v3';

let loadPromise: Promise<void> | null = null;

function drawWindArrowCanvas(size: number): HTMLCanvasElement {
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  if (!ctx) return canvas;

  const cx = size * 0.5;
  const shaftW = size * 0.14;

  ctx.clearRect(0, 0, size, size);
  ctx.fillStyle = '#0f172a';
  ctx.fillRect(cx - shaftW / 2, size * 0.34, shaftW, size * 0.54);
  ctx.beginPath();
  ctx.moveTo(cx, size * 0.08);
  ctx.lineTo(cx + size * 0.24, size * 0.36);
  ctx.lineTo(cx + size * 0.1, size * 0.36);
  ctx.lineTo(cx + size * 0.1, size * 0.34);
  ctx.lineTo(cx - size * 0.1, size * 0.34);
  ctx.lineTo(cx - size * 0.1, size * 0.36);
  ctx.lineTo(cx - size * 0.24, size * 0.36);
  ctx.closePath();
  ctx.fill();
  return canvas;
}

export function ensureWindArrowIcon(map: MapboxMap): Promise<void> {
  if (map.hasImage(WIND_ARROW_ICON_ID)) return Promise.resolve();
  if (loadPromise) return loadPromise;

  loadPromise = new Promise<void>((resolve, reject) => {
    try {
      const canvas = drawWindArrowCanvas(32);
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        resolve();
        return;
      }
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      if (!map.hasImage(WIND_ARROW_ICON_ID)) {
        map.addImage(WIND_ARROW_ICON_ID, imageData, { pixelRatio: 2 });
      }
      resolve();
    } catch (e) {
      reject(e);
    } finally {
      loadPromise = null;
    }
  });

  return loadPromise;
}
